import { convertTimeToMinutes, dayToNumber } from '../../../../shared/utils';
import { ModuleContractor } from '../../../types/contractor';
import { TimeArray } from '../../Experiences/Owner/Property/TimeArray';
import { SetMenuAsProvider } from '../../Reservations/ReservationRequest/ReservationJobs/ReservationJobForm';

export const getAvailableTimes = (
    contractor?: ModuleContractor | SetMenuAsProvider,
    selectedDate?: string | Date,
    startTime?: string | null,
    endTime?: string | null,
) => {
    if (!contractor || !selectedDate) return { startTimes: [], endTimes: [] };

    const date = new Date(selectedDate);
    const dayOfWeek = date.getDay();

    const dayAvailability = contractor.availableDays.find(
        (availability) => dayToNumber[availability.day] === dayOfWeek,
    );

    if (!dayAvailability) return { startTimes: [], endTimes: [] };

    const validTimes = dayAvailability.periods.length
        ? TimeArray.filter((time) =>
              dayAvailability.periods.some(
                  (period) =>
                      time.value >= period.from && time.value <= period.to,
              ),
          )
        : TimeArray;

    const startPeriod = startTime
        ? dayAvailability.periods.find(
              (period) => startTime >= period.from && startTime <= period.to,
          )
        : undefined;

    const endPeriod = endTime
        ? dayAvailability.periods.find(
              (period) => endTime >= period.from && endTime <= period.to,
          )
        : undefined;

    const startTimes = validTimes.filter((time) => {
        if (!endTime) return true;

        const withinPeriod = endPeriod
            ? time.value >= endPeriod.from && time.value <= endPeriod.to
            : true;

        return (
            convertTimeToMinutes(endTime) >=
                convertTimeToMinutes(time.value) + 30 && withinPeriod
        );
    });

    const endTimes = validTimes.filter((time) => {
        if (!startTime) return true;

        const withinPeriod = startPeriod
            ? time.value >= startPeriod.from && time.value <= startPeriod.to
            : true;

        return (
            convertTimeToMinutes(time.value) >=
                convertTimeToMinutes(startTime) + 30 && withinPeriod
        );
    });

    return { startTimes, endTimes };
};
